/** Textos do lote 3 (relógio de ponto): cadastro, importação do AFD e leitura pela API da Control iD. Sem travessão e sem emoji. */
const pt = {
  titulo: 'Relógios de ponto',
  aviso: 'O relógio certificado exporta o AFD pela porta fiscal (USB): importe o arquivo aqui. Nos relógios Control iD acessíveis pela internet, a leitura pode ser automática, a cada 30 minutos.',
  novo: 'Novo relógio',
  editar: 'Editar relógio',
  arquivar: 'Arquivar relógio',
  importar: 'Importar AFD',
  lerAgora: 'Ler agora',
  arquivo: 'Arquivo AFD',
  escolherArquivo: 'Escolher arquivo',
  trocarArquivo: 'Trocar arquivo',
  importacoes: 'Importações',
  verRelatorio: 'Ver relatório',
  baixarArquivo: 'Baixar o AFD',
  naFila: 'Importação na fila: o relatório aparece aqui quando terminar.',
  leituraNaFila: 'Leitura na fila: as marcações novas entram por uma importação.',
  avisoImportar: 'O arquivo precisa ser deste relógio (o número de série do cabeçalho) e da empresa dele (o CNPJ). Reimportar o mesmo arquivo não duplica: as marcações já gravadas contam como "já existentes".',
  avisoLeitura: 'Precisa do relógio acessível pela internet (ou de um coletor local) e do conector Control iD (usuário e senha da API do relógio) em Integrações > Conectores.',
  avisoCertificado: 'O certificado do relógio é guardado na primeira leitura; as seguintes só aceitam o mesmo. Confira a impressão digital com a do relógio.',
  semEmpresa: 'Escolha a empresa do relógio (a do CNPJ do AFD).',
  vazio: 'Nenhum relógio cadastrado.',
  vazioImportacoes: 'Nenhuma importação deste relógio ainda.',
  confirmarArquivar: 'Arquivar o relógio?',
  confirmarArquivarTexto: 'As marcações e as importações dele continuam. A leitura automática para.',
  campos: {
    nome: 'Nome',
    marca: 'Marca',
    modelo: 'Modelo',
    numeroSerie: 'Número de série',
    numeroSerieAjuda: 'O número de fabricação do relógio, o mesmo que vem no cabeçalho do AFD.',
    empresa: 'Empresa',
    empresaAjuda: 'A empresa do CNPJ que vem no AFD deste relógio.',
    local: 'Local',
    localAjuda: 'Onde o relógio fica (unidade, portaria).',
    fuso: 'Fuso horário',
    fusoAjuda: 'Vale para a hora do AFD no leiaute antigo (Portaria 1510), que não traz o fuso.',
    conferirCrc: 'Conferir o CRC das linhas',
    conferirCrcAjuda: 'Linha com o CRC errado é recusada. Desligue só para relógio que grava outro CRC.',
    ativo: 'Ativo',
    leituraAutomatica: 'Leitura automática (Control iD)',
    endereco: 'Endereço do relógio',
    enderecoAjuda: 'Com https, acessível pela internet (ex.: https://relogio.empresa.com.br:8443).',
    esquecerCertificado: 'Esquecer o certificado guardado',
    esquecerCertificadoAjuda: 'Use quando o relógio ou o certificado dele forem trocados: a próxima leitura guarda o novo.',
    certificado: 'Certificado do relógio',
    ultimoNsr: 'Último NSR lido',
    ultimaLeitura: 'Última leitura',
    ultimoErro: 'Último erro',
    marcacoes: 'Marcações',
    origem: 'Origem',
    estado: 'Situação',
    leiaute: 'Leiaute',
    periodo: 'Período do arquivo',
    nsr: 'NSR',
    lidas: 'Lidas',
    gravadas: 'Gravadas',
    existentes: 'Já existentes',
    semFuncionario: 'Sem funcionário',
    periodoFechado: 'Em mês fechado',
    crcInvalido: 'CRC errado',
    invalidas: 'Inválidas',
    outros: 'Outros registros',
    foraDeOrdem: 'NSR fora de ordem',
    lacunas: 'Saltos no NSR',
    pedidoPor: 'Pedido por',
    pedidoEm: 'Pedido em',
    concluidaEm: 'Concluída em',
    linha: 'Linha',
    motivo: 'Motivo',
    recusas: 'Linhas recusadas',
  },
  marca: { controlid: 'Control iD', henry: 'Henry', dimep: 'Dimep', madis: 'Madis', topdata: 'Topdata', secullum: 'Secullum', outra: 'Outra' },
  origem: { arquivo: 'Arquivo enviado', api: 'Leitura pela API' },
  estado: { na_fila: 'Na fila', processando: 'Importando', concluida: 'Concluída', erro: 'Recusada' },
  leiaute: { '1510': 'Portaria 1510/2009', '671': 'Portaria 671/2021' },
  recusa: {
    'afd.linha_invalida': 'Linha fora do tamanho do leiaute',
    'afd.data_invalida': 'Data ou hora da marcação inválida',
    'afd.documento_invalido': 'CPF ou PIS inválido',
    'afd.nsr_repetido': 'NSR repetido no arquivo',
    'afd.registro_desconhecido': 'Registro que não é do leiaute do AFD',
    'afd.crc_invalido': 'O CRC da linha não confere',
    'afd.hora_futura': 'Marcação com data no futuro: confira a hora do relógio',
    'afd.sem_pis': 'Leiaute antigo identifica pelo PIS, que o Pessoas não guarda: exporte o AFD da Portaria 671',
    'afd.sem_funcionario': 'Nenhum funcionário com este CPF e vínculo que bate ponto na empresa do relógio',
    'afd.periodo_fechado': 'O ponto deste mês já foi fechado para o funcionário',
  },
};

const en: typeof pt = {
  titulo: 'Time clocks',
  aviso: 'A certified time clock exports the AFD through its fiscal port (USB): import the file here. Control iD clocks reachable over the internet can be read automatically every 30 minutes.',
  novo: 'New time clock',
  editar: 'Edit time clock',
  arquivar: 'Archive time clock',
  importar: 'Import AFD',
  lerAgora: 'Read now',
  arquivo: 'AFD file',
  escolherArquivo: 'Choose file',
  trocarArquivo: 'Change file',
  importacoes: 'Imports',
  verRelatorio: 'View report',
  baixarArquivo: 'Download the AFD',
  naFila: 'Import queued: the report shows up here when it finishes.',
  leituraNaFila: 'Read queued: new punches come in through an import.',
  avisoImportar: 'The file must come from this clock (the serial number in the header) and its company (the tax ID). Importing the same file again does not duplicate: punches already saved count as "already existing".',
  avisoLeitura: 'Requires the clock reachable over the internet (or a local collector) and the Control iD connector (the clock API user and password) under Integrations > Connectors.',
  avisoCertificado: 'The clock certificate is saved on the first read; later reads only accept the same one. Compare the fingerprint with the one on the clock.',
  semEmpresa: 'Choose the clock company (the one of the AFD tax ID).',
  vazio: 'No time clock registered.',
  vazioImportacoes: 'No imports from this clock yet.',
  confirmarArquivar: 'Archive the time clock?',
  confirmarArquivarTexto: 'Its punches and imports remain. Automatic reading stops.',
  campos: {
    nome: 'Name',
    marca: 'Brand',
    modelo: 'Model',
    numeroSerie: 'Serial number',
    numeroSerieAjuda: 'The clock manufacturing number, the same one in the AFD header.',
    empresa: 'Company',
    empresaAjuda: 'The company of the tax ID in this clock\'s AFD.',
    local: 'Location',
    localAjuda: 'Where the clock is (unit, front desk).',
    fuso: 'Time zone',
    fusoAjuda: 'Applies to the AFD time in the old layout (Portaria 1510), which has no time zone.',
    conferirCrc: 'Check line CRC',
    conferirCrcAjuda: 'A line with a wrong CRC is refused. Turn off only for a clock that writes another CRC.',
    ativo: 'Active',
    leituraAutomatica: 'Automatic reading (Control iD)',
    endereco: 'Clock address',
    enderecoAjuda: 'With https, reachable over the internet (e.g. https://clock.company.com:8443).',
    esquecerCertificado: 'Forget the saved certificate',
    esquecerCertificadoAjuda: 'Use it when the clock or its certificate is replaced: the next read saves the new one.',
    certificado: 'Clock certificate',
    ultimoNsr: 'Last NSR read',
    ultimaLeitura: 'Last read',
    ultimoErro: 'Last error',
    marcacoes: 'Punches',
    origem: 'Source',
    estado: 'Status',
    leiaute: 'Layout',
    periodo: 'File period',
    nsr: 'NSR',
    lidas: 'Read',
    gravadas: 'Saved',
    existentes: 'Already existing',
    semFuncionario: 'No employee',
    periodoFechado: 'In a closed month',
    crcInvalido: 'Wrong CRC',
    invalidas: 'Invalid',
    outros: 'Other records',
    foraDeOrdem: 'NSR out of order',
    lacunas: 'NSR gaps',
    pedidoPor: 'Requested by',
    pedidoEm: 'Requested at',
    concluidaEm: 'Finished at',
    linha: 'Line',
    motivo: 'Reason',
    recusas: 'Refused lines',
  },
  marca: { controlid: 'Control iD', henry: 'Henry', dimep: 'Dimep', madis: 'Madis', topdata: 'Topdata', secullum: 'Secullum', outra: 'Other' },
  origem: { arquivo: 'Uploaded file', api: 'API read' },
  estado: { na_fila: 'Queued', processando: 'Importing', concluida: 'Finished', erro: 'Refused' },
  leiaute: { '1510': 'Portaria 1510/2009', '671': 'Portaria 671/2021' },
  recusa: {
    'afd.linha_invalida': 'Line outside the layout size',
    'afd.data_invalida': 'Invalid punch date or time',
    'afd.documento_invalido': 'Invalid CPF or PIS',
    'afd.nsr_repetido': 'NSR repeated in the file',
    'afd.registro_desconhecido': 'Record that is not in the AFD layout',
    'afd.crc_invalido': 'The line CRC does not match',
    'afd.hora_futura': 'Punch dated in the future: check the clock time',
    'afd.sem_pis': 'The old layout identifies by PIS, which People does not store: export the Portaria 671 AFD',
    'afd.sem_funcionario': 'No employee with this CPF and a clock-in employment at the clock company',
    'afd.periodo_fechado': 'This month is already closed for the employee',
  },
};

const es: typeof pt = {
  titulo: 'Relojes de control',
  aviso: 'El reloj certificado exporta el AFD por el puerto fiscal (USB): importa el archivo aquí. En los relojes Control iD accesibles por internet, la lectura puede ser automática, cada 30 minutos.',
  novo: 'Nuevo reloj',
  editar: 'Editar reloj',
  arquivar: 'Archivar reloj',
  importar: 'Importar AFD',
  lerAgora: 'Leer ahora',
  arquivo: 'Archivo AFD',
  escolherArquivo: 'Elegir archivo',
  trocarArquivo: 'Cambiar archivo',
  importacoes: 'Importaciones',
  verRelatorio: 'Ver informe',
  baixarArquivo: 'Descargar el AFD',
  naFila: 'Importación en cola: el informe aparece aquí cuando termine.',
  leituraNaFila: 'Lectura en cola: los registros nuevos entran por una importación.',
  avisoImportar: 'El archivo debe ser de este reloj (el número de serie del encabezado) y de su empresa (el CNPJ). Importar el mismo archivo de nuevo no duplica: los registros ya guardados cuentan como "ya existentes".',
  avisoLeitura: 'Requiere el reloj accesible por internet (o un colector local) y el conector Control iD (usuario y contraseña de la API del reloj) en Integraciones > Conectores.',
  avisoCertificado: 'El certificado del reloj se guarda en la primera lectura; las siguientes solo aceptan el mismo. Compara la huella con la del reloj.',
  semEmpresa: 'Elige la empresa del reloj (la del CNPJ del AFD).',
  vazio: 'Ningún reloj registrado.',
  vazioImportacoes: 'Ninguna importación de este reloj todavía.',
  confirmarArquivar: '¿Archivar el reloj?',
  confirmarArquivarTexto: 'Sus registros e importaciones siguen. La lectura automática se detiene.',
  campos: {
    nome: 'Nombre',
    marca: 'Marca',
    modelo: 'Modelo',
    numeroSerie: 'Número de serie',
    numeroSerieAjuda: 'El número de fabricación del reloj, el mismo del encabezado del AFD.',
    empresa: 'Empresa',
    empresaAjuda: 'La empresa del CNPJ que viene en el AFD de este reloj.',
    local: 'Ubicación',
    localAjuda: 'Dónde está el reloj (unidad, portería).',
    fuso: 'Huso horario',
    fusoAjuda: 'Vale para la hora del AFD en el formato antiguo (Portaria 1510), que no trae el huso.',
    conferirCrc: 'Verificar el CRC de las líneas',
    conferirCrcAjuda: 'La línea con el CRC errado se rechaza. Apágalo solo para un reloj que graba otro CRC.',
    ativo: 'Activo',
    leituraAutomatica: 'Lectura automática (Control iD)',
    endereco: 'Dirección del reloj',
    enderecoAjuda: 'Con https, accesible por internet (ej.: https://reloj.empresa.com:8443).',
    esquecerCertificado: 'Olvidar el certificado guardado',
    esquecerCertificadoAjuda: 'Úsalo cuando se cambien el reloj o su certificado: la próxima lectura guarda el nuevo.',
    certificado: 'Certificado del reloj',
    ultimoNsr: 'Último NSR leído',
    ultimaLeitura: 'Última lectura',
    ultimoErro: 'Último error',
    marcacoes: 'Registros',
    origem: 'Origen',
    estado: 'Situación',
    leiaute: 'Formato',
    periodo: 'Período del archivo',
    nsr: 'NSR',
    lidas: 'Leídas',
    gravadas: 'Guardadas',
    existentes: 'Ya existentes',
    semFuncionario: 'Sin empleado',
    periodoFechado: 'En mes cerrado',
    crcInvalido: 'CRC errado',
    invalidas: 'Inválidas',
    outros: 'Otros registros',
    foraDeOrdem: 'NSR fuera de orden',
    lacunas: 'Saltos en el NSR',
    pedidoPor: 'Pedido por',
    pedidoEm: 'Pedido el',
    concluidaEm: 'Concluida el',
    linha: 'Línea',
    motivo: 'Motivo',
    recusas: 'Líneas rechazadas',
  },
  marca: { controlid: 'Control iD', henry: 'Henry', dimep: 'Dimep', madis: 'Madis', topdata: 'Topdata', secullum: 'Secullum', outra: 'Otra' },
  origem: { arquivo: 'Archivo enviado', api: 'Lectura por la API' },
  estado: { na_fila: 'En cola', processando: 'Importando', concluida: 'Concluida', erro: 'Rechazada' },
  leiaute: { '1510': 'Portaria 1510/2009', '671': 'Portaria 671/2021' },
  recusa: {
    'afd.linha_invalida': 'Línea fuera del tamaño del formato',
    'afd.data_invalida': 'Fecha u hora del registro inválida',
    'afd.documento_invalido': 'CPF o PIS inválido',
    'afd.nsr_repetido': 'NSR repetido en el archivo',
    'afd.registro_desconhecido': 'Registro que no es del formato del AFD',
    'afd.crc_invalido': 'El CRC de la línea no coincide',
    'afd.hora_futura': 'Registro con fecha en el futuro: revisa la hora del reloj',
    'afd.sem_pis': 'El formato antiguo identifica por el PIS, que Personas no guarda: exporta el AFD de la Portaria 671',
    'afd.sem_funcionario': 'Ningún empleado con este CPF y vínculo que marca jornada en la empresa del reloj',
    'afd.periodo_fechado': 'La jornada de este mes ya fue cerrada para el empleado',
  },
};

export const i18nRelogio = { pt, en, es };
